import { CustomAction } from '../index';

export const replaceGeneric = (action_type: string, new_list: any[]): CustomAction => {
    return {
        type: action_type,
        payload: new_list.length > 0 ? new_list : null
    }
}

export const pushGeneric = (action_type: string, new_items: any[]): CustomAction => {
    return {
        type: action_type,
        payload: new_items.length > 0 ? new_items : null
    }
}

export const putGeneric = (action_type: string, new_item: any): CustomAction => {

    return {
        type: action_type,
        payload: new_item
    }
}

export const removeGeneric = (action_type: string, item_id: string): CustomAction => {
    return {
        type: action_type,
        payload: item_id
    }
}

export const selectGeneric = (action_type: string, new_item: any): CustomAction => {
    return {
        type: action_type,
        payload: new_item
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/generic.actions.ts